import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import PhotoUpload from "../../components/PhotoUpload";
import { listStaff } from "../../api/staffApi";
import { listClassConfigurations } from "../../api/classConfigurationApi";
import { listClassTeacherSignatures, saveClassTeacherSignature, deleteClassTeacherSignature } from "../../api/classTeacherSignatureApi";
import "../Attendance/Attendance.css";
import "../Users/UsersPage.css";

/**
 * Direct port of digicampusbd's `class-wise-teacher-signature` ("Teacher
 * wise Signature") — one signature image per section, attributed to a
 * specific teacher. New `ClassTeacherSignature` entity/repository/service/
 * controller (at most one row per section, delete-then-recreate on save —
 * same pattern as `default-signature`), reusing the already-built generic
 * `FileStorageService`/`PhotoUpload` component for the image.
 */
export default function ClassTeacherSignaturePage() {
  const [staffList, setStaffList] = useState([]);
  const [staffId, setStaffId] = useState("");
  const [classConfigs, setClassConfigs] = useState([]);
  const [classConfigId, setClassConfigId] = useState("");
  const [signatures, setSignatures] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const load = () => listClassTeacherSignatures().then(setSignatures);

  useEffect(() => {
    listStaff().then((list) => {
      setStaffList(list);
      if (list.length > 0) setStaffId(String(list[0].staffId));
    });
    listClassConfigurations().then((configs) => {
      setClassConfigs(configs);
      if (configs.length > 0) setClassConfigId(String(configs[0].id));
    });
    load();
  }, []);

  const handleUploadNew = async (file) => {
    setError("");
    setSuccess("");
    if (!staffId || !classConfigId) {
      setError("Please select a staff member and a section.");
      throw new Error("missing selection");
    }
    await saveClassTeacherSignature(classConfigId, staffId, file);
    setSuccess("Signature saved.");
    load();
  };

  const handleUploadExisting = (sig) => async (file) => {
    await saveClassTeacherSignature(sig.classConfigId, sig.staffId, file);
    load();
  };

  const handleDelete = async (signatureId) => {
    if (!window.confirm("Delete this signature?")) return;
    try {
      await deleteClassTeacherSignature(signatureId);
      load();
    } catch (err) {
      setError("Failed to delete signature.");
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Teacher Wise Signature</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      {success && <p style={{ color: "var(--color-success, green)" }}>{success}</p>}
      <div className="attendance-filters">
        <label>
          Staff
          <select value={staffId} onChange={(e) => setStaffId(e.target.value)}>
            {staffList.map((s) => (
              <option key={s.staffId} value={s.staffId}>
                {s.staffName}
              </option>
            ))}
          </select>
        </label>
        <label>
          Section
          <select value={classConfigId} onChange={(e) => setClassConfigId(e.target.value)}>
            {classConfigs.map((c) => (
              <option key={c.id} value={c.id}>
                {c.classConfigName}
              </option>
            ))}
          </select>
        </label>
      </div>
      <PhotoUpload folder="signatures" fileName={null} onUpload={handleUploadNew} />

      <div className="table-scroll">
        <table className="attendance-table">
          <thead>
            <tr>
              <th>Section</th>
              <th>Staff</th>
              <th>Signature</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {signatures.map((s) => (
              <tr key={s.signatureId}>
                <td>{s.classConfigName}</td>
                <td>{s.staffName}</td>
                <td>
                  <PhotoUpload folder="signatures" fileName={s.signImageName} onUpload={handleUploadExisting(s)} />
                </td>
                <td>
                  <button type="button" className="btn-link danger" onClick={() => handleDelete(s.signatureId)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {signatures.length === 0 && (
              <tr>
                <td colSpan={4}>No section signatures configured yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MainLayout>
  );
}
